import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { PartialDamageReportDetailInterface } from '../definitions/partial-damage-report-detail.interface';

@Injectable({ providedIn: 'root' })
export class PartialDamageReportLatestDetailService {
  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public latestDetail(taskId: string): Observable<PartialDamageReportDetailInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/partial-damage-report`;

    return this.client.get<PartialDamageReportDetailInterface>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
